<div *ngIf="data$ | async as data" class="signup">
  <div class="frame">
    <div class="logo" [style.backgroundColor]="data.partner?.loginHeaderBackground">
      <img [src]="data.partner?.logoUrl" />
    </div>

    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="SignUpState.Default" class="login-options-container">
        <h1>Sign up</h1>
        <ng-container *ngIf="!data.bundleHasSGNumber">
          <button (click)="state = SignUpState.SignUpEmail" mat-stroked-button class="w-full">
            Sign up with email
          </button>
          <div class="secondary-text or">OR</div>
        </ng-container>

        <div class="singpass-container">
          <div class="label">For individual</div>
          <button
            (click)="signup(SignUpType.SingPass)"
            [loading]="creatingLink[SignUpType.SingPass]"
            class="w-full"
            mat-stroked-button
          >
            <div class="singpass-btn">
              <img class="singpass-logo" src="assets/svg/singpass_logo.svg" />
              <img class="singpass-inline-button" src="assets/svg/singpass_inline_button.svg" />
            </div>
          </button>
        </div>

        <div class="corppass-container">
          <div class="label">For business entity</div>
          <button
            (click)="signup(SignUpType.CorpPass)"
            [loading]="creatingLink[SignUpType.CorpPass]"
            class="w-full"
            mat-stroked-button
          >
            <div class="corppass-btn">
              <img class="corppass-logo" src="assets/svg/myinfobiz_logo_inline.svg" />
              <img class="corppass-inline-button" src="assets/svg/myinfobiz_inline.svg" />
            </div>
          </button>
        </div>

        <div class="description">
          Verification of Singpass and CorpPass are required as per Singapore IMDA regulations for the purchase of
          numbers. Data is handled according to PDPA laws in Singapore.
        </div>

        <div class="has-account">
          <div>Already have an account?</div>
          <button mat-button color="primary" (click)="navigate2Login()">Sign in</button>
        </div>
      </div>

      <div *ngSwitchCase="SignUpState.SignUpEmail" class="w-full">
        <b3n-signup-email [redirectUrl]="redirectUrl" (backEvent)="state = SignUpState.Default"></b3n-signup-email>
      </div>
    </ng-container>
  </div>
</div>
